import axios from "axios";

export const sponsersData = () => {
    return axios
      .get("/sponsers")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };